import React from 'react'
import {Table} from 'reactstrap'
import _ from 'lodash'
import BudgetLabel from '../global/BudgetLabel'

const BudgetBreakdown = ({budgets, onBudgetPressed}) => {

    if (!budgets || !budgets.length) return <p>No Data</p>

    const {format} = Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
    })

    const grandBudgetTotal = _.sumBy(budgets, 'budget_total')
    const grandBudgetUsed = _.sumBy(budgets, 'budget_used')
    const grandSupplierTotal = _.sumBy(budgets, 'supplier_total')
    const grandBudgetRemaining = grandBudgetTotal - grandBudgetUsed - grandSupplierTotal

    return (


        <Table hover>
            <thead>

            <tr>
                <th>Description</th>
                <th>Budget</th>
                <th>Used (Gravity)</th>
                <th>Used (Supplier)</th>
                <th>Remaining</th>
            </tr>
            </thead>
            <tbody>
            {budgets.map((budget) => {
                const {id, description, budget_total, budget_used, stage, address, supplier_total, project_activity_type} = budget
                return (
                    <tr key={id} onClick={() => onBudgetPressed(budget)}>
                        <td>
                            <BudgetLabel
                                description={project_activity_type.description}
                                detail={description}
                                address={address ? address.full_address : ''}
                                stage={stage}
                            />
                        </td>
                        <td>{format(budget_total)}</td>
                        <td>{format(budget_used)}</td>
                        <td>{format(supplier_total)}</td>
                        <td>{format(budget_total - budget_used - supplier_total)}</td>
                    </tr>
                )
            })}
            </tbody>
            <tfoot>
                <tr>
                    <td className="font-weight-bold">Total</td>
                    <td className="font-weight-bold">{format(grandBudgetTotal)}</td>
                    <td className="font-weight-bold">{format(grandBudgetUsed)}</td>
                    <td className="font-weight-bold">{format(grandSupplierTotal)}</td>
                    <td className="font-weight-bold">{format(grandBudgetRemaining)}</td>
                </tr>
            </tfoot>
        </Table>


    )

}


export default BudgetBreakdown